/**
 * The audio currently open in Analysis mode. PCM arrays are large, so the document is
 * held with $state.raw (never deep-proxied); replace the whole object to update.
 */

export interface AudioDoc {
  id: string;
  name: string;
  sampleRate: number;
  channels: Float32Array[];
  source: 'generated' | 'file' | 'recording';
  /** e.g. generator parameters or original file format */
  note?: string;
}

class Session {
  doc = $state.raw<AudioDoc | null>(null);

  open(doc: Omit<AudioDoc, 'id'>): void {
    this.doc = { ...doc, id: crypto.randomUUID() };
  }
}

export const session = new Session();
